import api from '@/shared/api';
import type { ApiResponse } from '@/shared/lib';
import type { EditHomologationFormData } from '../model/editHomologation.types';

function removeUndefinedProperties<T>(obj: T): T {
  if (obj === null || obj === undefined) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(item => removeUndefinedProperties(item)) as T;
  }

  if (typeof obj === 'object') {
    const cleaned: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(obj)) {
      if (value !== undefined) {
        cleaned[key] = removeUndefinedProperties(value);
      }
    }
    return cleaned as T;
  }

  return obj;
}

class EditHomologationApi {
  async updateHomologation(
    revisionId: number,
    data: EditHomologationFormData
  ): Promise<ApiResponse<unknown>> {
    const cleanedData = removeUndefinedProperties(data);
    const response = await api.patch<ApiResponse<unknown>>(
      `/document-revisions/${revisionId}/homologation`,
      cleanedData
    );
    return response.data;
  }
}

export default new EditHomologationApi();

